<!--
  EmptyState Component
  Shows a message + optional icon and CTA when no data is available.
-->
<script lang="ts">
  export let title: string;
  export let description: string | undefined = undefined;
</script>

<div class="flex flex-col items-center justify-center py-12 text-center">
  {#if $$slots.icon}
    <div class="mb-4 text-text-muted">
      <slot name="icon" />
    </div>
  {/if}

  <h3 class="text-lg font-semibold text-text-secondary mb-1">{title}</h3>

  {#if description}
    <p class="text-sm text-text-muted max-w-sm">{description}</p>
  {/if}

  {#if $$slots.action}
    <div class="mt-4">
      <slot name="action" />
    </div>
  {/if}
</div>
